import { Tooltip } from "@mui/material";
import React, { useState } from "react";
import { useId } from "react";

const Checkbox = ({
  label,
  checked,
  onChange,
  disabled,
  customStyles,
  tooltipText,
  tooltipPlacement,
  customLabelStyles,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const id = useId();

  const handleMouseEnter = () => {
    if (tooltipText) {
      setShowTooltip(true);
    }
  };

  const handleMouseLeave = () => {
    if (tooltipText) {
      setShowTooltip(false);
    }
  };

  return (
    <div
      style={{ position: "relative", display: "inline-block", width: "100%" }}
    >
      <Tooltip title={tooltipText} placement={tooltipPlacement || "top"}>
        <span
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          style={{
            display: "inline-flex",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <input
            id={id}
            style={{ ...customStyles, cursor: "pointer" }}
            type="checkbox"
            checked={checked}
            onChange={onChange}
            disabled={!!disabled}
          />
          <label
            htmlFor={id}
            style={{
              marginLeft: "0.5em",
              cursor: "pointer",
              color: customStyles?.color || "inherit",
              ...customLabelStyles,
            }}
          >
            {label}
          </label>
        </span>
      </Tooltip>
    </div>
  );
};

export default Checkbox;
